/* Diwali countdown: every element with data-dw-countdown and a data-date
   (YYYY-MM-DD, counted to midnight India time) ticks once a second.
   Inside it, [data-dw-d] [data-dw-h] [data-dw-m] [data-dw-s] get the numbers.
   When the date has passed the element gets .is-done so its "done" text shows.
   Framework free. */
(function () {
  'use strict';

  var items = [];
  var timer = 0;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function set(el, key, value) {
    var node = el.querySelector('[data-dw-' + key + ']');
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tick() {
    var now = Date.now();
    items.forEach(function (item) {
      var diff = item.end - now;
      if (diff <= 0) {
        item.el.classList.add('is-done');
        return;
      }
      item.el.classList.remove('is-done');
      var total = Math.floor(diff / 1000);
      set(item.el, 'd', pad(Math.floor(total / 86400)));
      set(item.el, 'h', pad(Math.floor(total % 86400 / 3600)));
      set(item.el, 'm', pad(Math.floor(total % 3600 / 60)));
      set(item.el, 's', pad(total % 60));
    });
  }

  function init(scope) {
    var nodes = Array.prototype.slice.call((scope || document).querySelectorAll('[data-dw-countdown]'));
    if (scope && scope.matches && scope.matches('[data-dw-countdown]')) nodes.push(scope);
    nodes.forEach(function (el) {
      if (el.dataset.dwReady === 'true') return;
      var end = Date.parse((el.dataset.date || '') + 'T00:00:00+05:30');
      if (isNaN(end)) { el.hidden = true; return; }
      el.dataset.dwReady = 'true';
      items.push({ el: el, end: end });
    });
    if (items.length && !timer) {
      tick();
      timer = window.setInterval(function () { if (!document.hidden) tick(); }, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    items = items.filter(function (item) { return !event.target.contains(item.el); });
  });
})();
